import { Injectable } from '@angular/core';

export interface PaginationConfig {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  maxPages: number;
}

@Injectable({
  providedIn: 'root'
})
export class ClientPaginationService {

  constructor() { }

  /**
   * Initialize pagination configuration
   */
  initializePagination(totalItems: number, pageSize: number = 10): PaginationConfig {
    return {
      currentPage: 1,
      pageSize: pageSize,
      totalItems: totalItems,
      maxPages: Math.ceil(totalItems / pageSize)
    };
  }

  /**
   * Get paginated data slice
   */
  getPaginatedData<T>(data: T[], config: PaginationConfig): T[] {
    const startIndex = (config.currentPage - 1) * config.pageSize;
    const endIndex = startIndex + config.pageSize;
    return data.slice(startIndex, endIndex);
  }

  /**
   * Change page and return updated config
   */
  changePage(config: PaginationConfig, newPage: number): PaginationConfig {
    return {
      ...config,
      currentPage: newPage,
      maxPages: Math.ceil(config.totalItems / config.pageSize)
    };
  }

  /**
   * Change page size and return updated config
   */
  changePageSize(config: PaginationConfig, newPageSize: number): PaginationConfig {
    return {
      ...config,
      currentPage: 1,
      pageSize: newPageSize,
      maxPages: Math.ceil(config.totalItems / newPageSize)
    };
  }

  /**
   * Update total items and recalculate max pages
   */
  updateTotalItems(config: PaginationConfig, newTotal: number): PaginationConfig {
    return {
      ...config,
      totalItems: newTotal,
      maxPages: Math.ceil(newTotal / config.pageSize)
    };
  }
}